import { CheckCircle2, Sparkles } from "lucide-react";

const s = (v) => (typeof v === "string" ? v.trim() : v);

export function computeCompletion({ profile = {}, work = [], edu = [], skills = [] }) {
  const checks = [
    { key: "full_name", label: "your full name", done: !!s(profile.full_name) },
    { key: "email", label: "your email", done: !!s(profile.email) },
    { key: "phone", label: "your phone number", done: !!s(profile.phone) },
    { key: "location", label: "your location", done: !!s(profile.location) },
    { key: "summary", label: "a professional summary", done: !!s(profile.summary) },
    { key: "work", label: "your work experience", done: work.length > 0 },
    { key: "edu", label: "your education", done: edu.length > 0 },
    { key: "skills", label: "at least 3 skills", done: skills.length >= 3 },
  ];
  const done = checks.filter((c) => c.done).length;
  const percent = Math.round((done / checks.length) * 100);
  const next = checks.find((c) => !c.done);
  return { percent, next: next ? next.label : null };
}

export function ProfileCompletion({ profile, work, edu, skills }) {
  const { percent, next } = computeCompletion({ profile, work, edu, skills });
  const complete = percent === 100;
  return (
    <div className="bg-white border border-zinc-200 rounded-xl p-4 sm:p-5" data-testid="profile-completion">
      <div className="flex items-center justify-between gap-4 mb-2.5">
        <p className="text-sm font-medium flex items-center gap-1.5">
          {complete ? <CheckCircle2 className="h-4 w-4 text-green-600" /> : <Sparkles className="h-4 w-4 text-accent" />}
          {complete ? (
            <span>Your profile is complete — nice work!</span>
          ) : (
            <span data-testid="completion-text">Your profile is <strong>{percent}% complete</strong> — add {next} to reach 100%.</span>
          )}
        </p>
        <span className="text-sm font-bold tabular-nums" data-testid="completion-percent">{percent}%</span>
      </div>
      <div className="h-2 w-full rounded-full bg-zinc-100 overflow-hidden">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ease-out ${complete ? "bg-green-500" : "bg-accent"}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
